import { isMark } from './isMark.mjs';

function hasMark(leaf, type) {
  return isMark(leaf, type) && leaf[type] != null && leaf[type] !== false;
}

export { hasMark };
